import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputAdornment, TextField } from "@mui/material";

const SearchField = ({
  height = 46,
  value = "",
  sx = {},
  placeholder = "Search",
  handleSearch = () => {},
  handleChange = () => {},
  isHideIcon = false,
  onChange = () => {},
  fullWidth = true
}) => {
  return (
    <TextField
      autoComplete
      fullWidth={fullWidth}
      value={value}
      onChange={(e) => {
        handleChange(e.target.value);
        onChange(e.target.value);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleSearch(value);
        }
      }}
      // onBlur={() => handleSearch(value)}
      placeholder={placeholder}
      sx={{
        bgcolor: "#ffffff",
        height: `${height}px`,
        ...sx,
        "& .MuiOutlinedInput-root": {
          height: `${height}px`,
          fontSize: "14px",
        },
        "& .MuiInputBase-input": {
          marginLeft: !isHideIcon ? "-12px" : "0px",
        },
      }}
      InputProps={{
        startAdornment: !isHideIcon && (
          <InputAdornment position="start">
            <IconButton sx={{ marginLeft: "-10px" }}>
              <SearchIcon style={{ fontSize: "18px" }} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchField;
